import { render } from "./InfoProfile.vue?vue&type=template&id=6b55a7ca"
import script from "./InfoProfile.vue?vue&type=script&lang=ts"
export * from "./InfoProfile.vue?vue&type=script&lang=ts"

import "./InfoProfile.vue?vue&type=style&index=0&id=6b55a7ca&lang=scss"
script.render = render

export default script